import { render, staticRenderFns } from "./QuckBetItem.vue?vue&type=template&id=4b776af7&scoped=true"
import script from "./QuckBetItem.vue?vue&type=script&lang=ts"
export * from "./QuckBetItem.vue?vue&type=script&lang=ts"
import style0 from "./QuckBetItem.vue?vue&type=style&index=0&id=4b776af7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b776af7",
  null
  
)

export default component.exports